import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = ({ isAuthenticated  }) => {
  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;
